module.exports = __webpack_public_path__ + "img/smartcam-longback.5c5ca9a5.png";